import { createFileRoute } from '@tanstack/react-router'

import { NnppComponentDetailPage } from '@/src/pages/nnpp/components/NnppComponentDetailPage'

export const Route = createFileRoute('/nnpp/components/$componentId')({
  component: NnppComponentDetailPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
